const config = {
  wordPressURL: `https://admin.equityalliancemn.org/`,
}

export default config
